import * as React from "react";
import { useState } from "react";
import { Switch, Route, Link } from "react-router-dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";

import Frontpage from "./pages/Frontpage";
import Food from "./pages/Food";
import Drinks from "./pages/Drinks";
import Location from "./pages/Location";

const App: React.FC<IAppProps> = props => {
  const [isToggled, setIsToggled] = useState(false);
  const toggleClick = () => {
    setIsToggled(!isToggled);
  };

  const [navBackgroundColor, setNavBackgroundColor] = useState<string>("dark");
  const [toggledNavBackgroundColor, setToggledNavBackgroundColor] = useState<
    string
  >("transparent");
  const [navAccentColor, setNavAccentColor] = useState<any>("dark"); //need <any> otherwise the variant attr. won't play nice
  const [logoColor, setLogoColor] = useState<string>("white");
  const changeNavColor = (
    bgColor: string,
    toggledBgColor: string,
    accentColor: string,
    logoColor: string
  ) => {
    setNavBackgroundColor(bgColor);
    setToggledNavBackgroundColor(toggledBgColor);
    setNavAccentColor(accentColor);
    setLogoColor(logoColor);
  };
  React.useEffect(() => {
    const { pathname } = location;
    switch (pathname) {
      case "/": {
        disableBodyScroll(document.body);
        changeNavColor("dark", "transparent", "dark", "white");
        break;
      }
      case "/location": {
        disableBodyScroll(document.body);
        changeNavColor("dark", "transparent", "dark", "white");
        document.body.style.backgroundColor = "#AADAFF";
        break;
      }
      case "/food": {
        enableBodyScroll(document.body);
        changeNavColor("light", "light", "light", "black");
        document.body.style.backgroundColor = "#f8f9fa";
        break;
      }
      case "/drinks": {
        enableBodyScroll(document.body);
        changeNavColor("light", "light", "light", "black");
        document.body.style.backgroundColor = "#f8f9fa";
        break;
      }
      default: {
        enableBodyScroll(document.body);
        changeNavColor("light", "light", "light", "black");
        document.body.style.backgroundColor = "#f8f9fa";
        break;
      }
    }
  }, [location.pathname]);

  return (
    <div>
      <Navbar
        fixed="top"
        collapseOnSelect
        expand="lg"
        bg={isToggled ? navBackgroundColor : toggledNavBackgroundColor}
        variant={navAccentColor}
        onToggle={() => toggleClick()}
      >
        <Navbar.Brand
          style={{
            color: logoColor,
            fontSize: "2rem",
            fontFamily: "Gill Sans",
            fontWeight: 500,
            position: "relative",
            left: -3
          }}
        >
          Wow Viewpoint
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className={"mr-auto " + (isToggled ? "visible" : "invisible")}>
            <Nav.Link eventKey="1" as={Link} to="/">
              Home
            </Nav.Link>
            <Nav.Link eventKey="2" as={Link} to="/food">
              Food
            </Nav.Link>
            <Nav.Link eventKey="3" as={Link} to="/drinks">
              Drinks
            </Nav.Link>
            <Nav.Link eventKey="4" as={Link} to="/location">
              Location
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <main className="container" style={{ paddingTop: 70 }}>
        <Switch>
          <Route exact path="/" component={Frontpage} />
          <Route exact path="/food" component={Food} />
          <Route exact path="/drinks" component={Drinks} />
          <Route exact path="/location" component={Location} />
        </Switch>
      </main>
    </div>
  );
};

interface IAppProps {}

export default App;
